import SessionWizard from './SessionWizard.jsx';
import { summariseSession } from '../api/client.js';

function currentWeekMonday() {
  const d = new Date();
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 10);
}

const config = {
  sessionType: 'weekly',
  start: {
    title: 'Weekly meeting',
    description:
      'Sundays at 11:00. For each role: reflect on last week, then plan the coming week (with ad-hoc tasks that carry over). Closes with the awesome-because outcome + 3 levers. Answers can be typed or recorded.',
    buttonLabel: 'Start new session',
    inProgressLabel: 'In-progress sessions',
    resumeDateLabel: 'Week of',
  },
  startDate: currentWeekMonday,
  summarise: summariseSession,
  hasSummary: (s) => !!(s.debrief_summary && s.preview_summary),
  renderSummary: (s) => (
    <div className="space-y-4">
      <div className="space-y-1">
        <div className="text-xs uppercase tracking-wide text-slate-400">Weekly debrief</div>
        <div className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">
          {s.debrief_summary}
        </div>
      </div>
      <div className="space-y-1">
        <div className="text-xs uppercase tracking-wide text-slate-400">Weekly preview</div>
        <div className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">
          {s.preview_summary}
        </div>
      </div>
    </div>
  ),
  summary: {
    heading: 'AI summary',
    generateLabel: 'Generate summary',
    generatingLabel: 'Generating',
    regenerateLabel: 'Regenerate',
    regeneratingLabel: 'Regenerating',
    emptyTitle: 'Generate debrief + preview',
    emptyHint:
      'Sends your typed answers and voice transcripts to Claude. Saves both summaries to this session.',
    weekLabel: 'Week of',
  },
};

export default function WeeklyWizard() {
  return <SessionWizard config={config} />;
}
